<template>
    <div>
        <a class="btn btn-secondary mt-3 z-index-1" @click="goToUrl()">
            <slot></slot>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        to: {
            type: String,
            required: true,
        },
    },
    methods: {
        async goToUrl() {
            await fetch('/hubavocat/user', {
                method: 'PATCH',
                body: JSON.stringify({'willCompleteProfileLater': false}),
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
            });
            window.location = this.to;
        }
    }
};
</script>
